import axios from "axios";
var CryptoJS = require("crypto-js");

class DataApi {
    constructor() {
        this.URL = "https://" + process.env.VUE_APP_MAIN_URL + "/api/configuration";
        this.cryptageKey = "2687da56-4181-48a6-bec4-c526727423f8"
    }

    encrypt(datas) {
        return { data: CryptoJS.AES.encrypt(JSON.stringify(datas), this.cryptageKey).toString() }
    }

    decrypt(data) {
        var bytes = CryptoJS.AES.decrypt(data, this.cryptageKey);
        var originalData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return originalData
    }
    
    set_configuration_token(token, callback) {
        let datas = { token }
        axios.post(this.URL + '/v1/set_configuration_token', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        }).catch(() => {
            callback({ code: -1 });
        });
    }

    // Récupère le token de configuration actuellement utilisé.
    get_configuration_token(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_configuration_token', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        }).catch(() => {
            callback({ code: -1 });
        });
    }
}

export default new DataApi()